import {
  ItemPacking,
  TemperatureDegree,
  VehicleBrand,
  VehicleCountry,
  VehicleGroup,
  VehicleTypes,
  Weight,
} from '@hero/schema';

export type Spec = {
  id: VehicleTypes;
  /**
   * you can use this to indicate if the vehicle can handle chilled and frozen
   */
  isChilled: boolean;
  degrees?: TemperatureDegree;
  /** the default packing for the truck */
  packing: ItemPacking;
  /** the default quantity such 24 pallets */
  quantity: number;
  weight: Weight;
  /** the family of the vehicle such as truck / lorry / dyna */
  group: 'truck' | 'lorry' | 'dyna';
};

// trucks
const truck_flatbed: Spec = {
  id: 'truck_flatbed',
  isChilled: false,
  packing: 'pallet',
  quantity: 24,
  weight: {
    type: 'ton',
    value: 25,
  },
  group: 'truck',
};
const truck_curtain_side: Spec = {
  id: 'truck_curtain_side',
  isChilled: false,
  packing: 'pallet',
  quantity: 24,
  group: 'truck',
  weight: {
    type: 'ton',
    value: 25,
  },
};
const truck_chilled: Spec = {
  id: 'truck_chilled',
  isChilled: true,
  packing: 'pallet',
  quantity: 24,
  group: 'truck',
  weight: {
    type: 'ton',
    value: 25,
  },
};

// lorry
const lorry_open_top: Spec = {
  id: 'lorry_open_top',
  isChilled: false,
  packing: 'pallet',
  quantity: 8,
  group: 'lorry',
  weight: {
    type: 'ton',
    value: 6,
  },
};

const lorry_closed: Spec = {
  id: 'lorry_closed',
  isChilled: false,
  packing: 'pallet',
  quantity: 8,
  group: 'lorry',
  weight: {
    type: 'ton',
    value: 6,
  },
};
const lorry_chilled: Spec = {
  id: 'lorry_chilled',
  isChilled: true,
  packing: 'pallet',
  quantity: 8,
  group: 'lorry',
  weight: {
    type: 'ton',
    value: 6,
  },
};
// dyna
const dyna_open_top: Spec = {
  id: 'dyna_open_top',
  isChilled: false,
  packing: 'pallet',
  quantity: 5,
  group: 'dyna',
  weight: {
    type: 'ton',
    value: 4,
  },
};

const dyna_closed: Spec = {
  id: 'dyna_closed',
  isChilled: false,
  packing: 'pallet',
  quantity: 5,
  group: 'dyna',
  weight: {
    type: 'ton',
    value: 4,
  },
};
const dyna_chilled: Spec = {
  id: 'dyna_chilled',
  isChilled: true,
  packing: 'pallet',
  quantity: 5,
  group: 'dyna',
  weight: {
    type: 'ton',
    value: 4,
  },
};

export const types = [
  truck_chilled,
  truck_flatbed,
  truck_curtain_side,
  lorry_open_top,
  lorry_closed,
  lorry_chilled,
  dyna_open_top,
  dyna_closed,
  dyna_chilled,
] as const;

export const groupedTypes = {
  trucks: [truck_chilled, truck_flatbed, truck_curtain_side],
  dynas: [dyna_open_top, dyna_closed, dyna_chilled],
  lorries: [lorry_open_top, lorry_closed, lorry_chilled],
};

const brands: VehicleBrand[] = [
  'volvo',
  'mercedes',
  'isuzu',
  'toyota',
  'hino',
  'howo',
  'mitsubishi',
  'scania',
  'sinotruck',
  'other',
] as const;

const countries: VehicleCountry[] = [
  'saudi_arabia',
  'united_arab_emirates',
  'kuwait',
  'egypt',
  'jordan',
  'syria',
  'other',
];
export const vehicles = {
  /** vehicle types */
  types,
  /** vehicle brands */
  brands,
  /** the origin of the vehicle country */
  countries,
  /** grouped vehicle types */
  groupedTypes,
};
